export default __webpack_public_path__ + "static/media/research_green.7867afb6.svg";